import {CommandRequester} from '../../../CommandRequester';
import {
    Assets as AssetsRequester,
    FetchAssetToken,
    UnloadAssetToken,
} from './requesters/Assets';

/**
 * Commands for working with external assets
 * @namespace CommandRequester.assets
 */
export class Assets {

    private assetsRequester: AssetsRequester;

    constructor(requester:CommandRequester) {
        this.assetsRequester = new AssetsRequester(requester);
    }

    /**
     * Command to retrieve external asset and store in local cache by name.
     * @method CommandRequester.assets#load
     * @param  {string}   uri Uri where the asset to fetch is.
     * @param  {string}   name Name that the asset will be call by.
     * @returns {FetchAssetToken}
     */
    public load(uri: string, name: string): FetchAssetToken {
        const protocol = AssetsRequester.generateLoadProtocol(uri, name);
        return this.assetsRequester.generateToken(protocol, true) as FetchAssetToken;
    }

    /**
     * Command to unload asset by name.
     * @method CommandRequester.assets#unload
     * @param  {string}   name Name of asset to unload.
     * @return {UnloadAssetToken}
     */
    public unload(name: string): UnloadAssetToken {
        const protocol = AssetsRequester.generateUnloadProtocol(name);
        return this.assetsRequester.generateToken(protocol, true) as UnloadAssetToken;
    }
}
